<template>
	<div>
		<template v-for="(item, index) in list">
			<div v-if="item.listTop" class="listItem listTop" :key="'listItem'+index" @click="cardToggle">
				<div class="logoWrap">
					<div class="imgWrap">
						<img :src="$store.getters.getUrlPrefix + item.clientLogo" alt="">
					</div>
				</div>
				<div class="contentWrap">
					<div class="titleWrap" :style="{ backgroundImage: 'url(' + $store.getters.getUrlPrefix + item.mainImg + ')' }">
						<div class="txtWrap">
							<h3 class="titleTxt">{{item.workTitle}}</h3>
							<div class="client">{{item.clientName}}</div>
						</div>
						<div class="period">{{item.year}}</div>
						<div class="cover dark"></div>
					</div>
					<div class="detailWrap">
						<div class="slideWrap">
							<swiper class="innerSwiper" :options="swiperOption" v-if="item.detailImg">
								<swiper-slide v-for="(slide, slideIdx) in item.detailImg" :key="slideIdx"><div class="imgWrap imgCenter horizontal"><img :src="$store.getters.getUrlPrefix + slide.thumb" alt=""></div></swiper-slide>
								<div class="swiper-pagination" slot="pagination"></div>
							</swiper>
						</div>
						<div class="txtContWrap">
							<h4 class="titleTxt">Project Contents</h4>
							<div class="contentTxt"><p v-html="item.detail"></p></div>
							<BtnLink :portfolioPopupOpen="true" :linkData="list[index]" class="btnLink" color="#fff" size="is-small"></BtnLink>
						</div>
					</div>
				</div>
			</div>
			<div v-else class="listItem cardType" :key="'listItem'+index" @click="cardToggle">
				<div v-if="(index%3 == 1)||($store.state.device==='mobile')" class="logoWrap">
					<div class="imgWrap">
						<img :src="$store.getters.getUrlPrefix + item.clientLogo" alt="">
					</div>
				</div>
				<div class="contentWrap" :style="{ backgroundImage: 'url(' + $store.getters.getUrlPrefix + item.mainImg + ')' }">
					<div class="titleWrap">
						<div class="txtWrap">
							<h3 class="titleTxt">{{item.workTitle}}</h3>
							<div class="client">{{item.clientName}}</div>
						</div>
						<div class="period">{{item.year}}</div>
						<div class="cover dark"></div>
						<BtnLink :portfolioPopupOpen="true" :linkData="list[index]" class="btnLink showOpen" color="#fff" size="is-tiny"></BtnLink>
					</div>
					<div class="detailWrap" :style="{ backgroundColor: item.bgColor}">
						<div class="txtContWrap">
							<h4 class="titleTxt">Project Contents</h4>
							<div class="contentTxt"><p v-html="item.detail"></p></div>
							<BtnLink :portfolioPopupOpen="true" :linkData="list[index]" class="btnLink" color="#fff" size="is-tiny"></BtnLink>
						</div>
					</div>
				</div>
				<div v-if="((index%3 == 2)||(index%3 == 0))&&$store.state.device!=='mobile'" class="logoWrap">
					<div class="imgWrap">
						<img :src="$store.getters.getUrlPrefix + item.clientLogo" alt="">
					</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import { TweenMax, Expo } from 'gsap'
import BtnLink from '../components/ButtonLinkPage'
export default {
	name: 'ButtonLinkPage',
	components: {
		BtnLink
	},
	data () {
		return {
			swiperOption: {
				watchOverflow: true,
				loop: false,
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				}
			}
		}
	},
	props: {
		list: {
			type: Array,
			default: function () {
				return [{
					listTop: true,
					clientLogo: require('@/assets/images/partner-thumb-samsunglife@2x.png'),
					workTitle: '타이틀 명',
					clientName: '클라이언트 명',
					keyword: 'si',
					year: '2020',
					bgColor: 'rgba(0,48,85,0.9)',
					// mainImg: require('@/assets/images/portfolio-cover-samsunglife-2020newtablet@2x.jpg'),
					mainImg: '',
					detail: '설명 텍스트 (html)',
					detailImg: [
						{
							// thumb: require('@/assets/images/temp-portfolio-cj-enm-1000.png'),
							thumb: '',
							// img: require('@/assets/images/temp-portfolio-cj-enm-1000.png'),
							img: '',
							link: ''
						}
					],
					link: ''
				}]
			}
		}
	},
	methods: {
		cardToggle (e) {
			var tg = e.currentTarget
			tg.classList.toggle('on')
			var txtWrap = tg.querySelector('.detailWrap')
			var h = txtWrap.querySelector('.txtContWrap').offsetHeight
			if (this.$store.state.device === 'mobile') {
				if (tg.classList.contains('on')) {
					TweenMax.killTweensOf(txtWrap)
					TweenMax.fromTo(txtWrap, { height: 0 }, { height: h + 'px', duration: 0.8, ease: Expo.easeInOut })
				} else {
					TweenMax.killTweensOf(txtWrap)
					TweenMax.fromTo(txtWrap, { height: h + 'px' }, { height: 0, duration: 0.8, ease: Expo.easeInOut })
				}
			} else {
				txtWrap.style.height = null
			}
		}
	}
}
</script>

<style lang="scss">
@import '@/css/variables.scss';
/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	.portfolioWrap {
		.portfolioList {
			.portfolioCompWrap {
				.listItem {
					&.listTop {
						.contentWrap {
							.detailWrap {
								.txtContWrap {
									.btnLinkWrap {
										a {
											padding: 0;
										}
									}
								}
							}
						}
					}
					&.cardType {
						.contentWrap {
							.titleWrap {
								.btnLinkWrap {
									.is-tiny {
										transform: scale(0.75);
									}
								}
							}
							.detailWrap {
								.txtContWrap {
									.btnLinkWrap {
										.is-tiny {
											transform: scale(0.75);
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
	//css
}
/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
	//CSS
	.portfolioWrap {
		.portfolioList {
			.portfolioCompWrap {
				.listItem {
					&.cardType {
						.contentWrap {
							.titleWrap {
								.btnLinkWrap {
									.is-tiny {
										transform: scale(0.75);
									}
								}
							}
							.detailWrap {
								.txtContWrap {
									.btnLinkWrap {
										width: 50px; height: 50px;
										.is-tiny {
											transform: scale(0.75);
										}
									}
								}
							}
						}
					}
				}
			}
		}
	}
}
</style>

<style lang="scss" scoped>
@import '@/css/variables.scss';
$multiple: 4;
$w: 100px*$multiple;
$h: 100px*$multiple;
.listItem {
	position: relative;
	display: inline-block;
	float: left;
	text-align: left;
	&.listTop {
		/* width: 100%; */ width: $w*3; height: $h;
		margin-bottom: 20px; margin-left: 10px;
		&:nth-child(2n+1) {
			margin-left: -10px;
		}
		box-shadow: 0 20px 40px rgba(0,0,0,0.3);
		.logoWrap {
			position: relative; display: block; float: right;
			width: $w; height: $h;
			background-color: $c-white;
			.imgWrap {
				img {max-width: 70%;}
			}
		}
		.contentWrap {
			position: relative; display: block; float: left;
			width: #{$w*2}; height: $w;
			overflow: hidden;
			.titleWrap {
				@include transition(0.4s);
				position: relative; display: inline-block;
				width: #{$w*2}; height: $w;
				background-size: cover; background-position: center center;
				.txtWrap {
					$mgTitle: 50px;
					@include transition(0.4s);
					position: absolute;
					bottom: $mgTitle; left: $mgTitle;
					color: $c-white;
					width: calc(100% - #{$mgTitle*2});
					z-index: 3;
					.titleTxt {
						@include transition(0.4s);
						width: 100%;
						font-size: $title-medium-small;
						/* font-size: 2.6vw; */
						margin-bottom: 10px;
					}
					.client {
						@include transition(0.4s);
						font-size: $text-normal;
						/* font-size: 1.6vw; */
					}
				}
				.period {
					position: absolute;
					z-index: 2;
					top: 20px; right: 24px;
					color: $c-white; font-size: $text-medium;
				}
				.cover {
					position: absolute;
					left: 0; top: 0;
					width: 100%; height: 100%;
					z-index: 1;
					&.dark {background-color: rgba($c-black, 0.4);}
				}
			}
			.detailWrap {
				@include transition(0.4s);
				position: absolute;
				top: 0; left: 100%;
				width: $w; height: $h;
				margin-left: 0;
				background-color: $c-blue-dark;
				.slideWrap {
					position: absolute;
					top: 0; left: 0;
					width: 100%; height: #{$w/2};
					background-color: $c-black;
					.swiper-container {
						height: #{$w/2};
					}
				}
				.txtContWrap {
					position: absolute;
					top: 50%; left: 0;
					width: 100%; height: 50%;
					padding: 6%;
					.titleTxt {
						width: 88%;
						font-size: $title-tiny; /* font-size: 1.5vw; */ font-weight: bold;
						color: $c-white;
						margin-bottom: 12px;
					}
					.contentTxt {
						$lineNum: $multiple+1;
						$lh: 1.22em;
						position: relative;
						width: $w*0.8;
						height: $lh*$lineNum;
						color: $c-gray-light2;
						p {
							display: -webkit-box;
							height: $lh*$lineNum - 0.02em;
							line-height: $lh;
							text-overflow: ellipsis;
							overflow: hidden;
							-webkit-line-clamp: $lineNum;
							-webkit-box-orient: vertical;
						}
					}
					.btnLink {
						position: absolute;
						right: 0;
						bottom: 0;
						width: $w/8; height: $h/8;
						background-color: $c-blue-m;
					}
				}
			}
		}
		&:hover, &.on {
			.contentWrap {
				.titleWrap {
					width: $w;
					.txtWrap {
						left: 40px;
						.titleTxt {
							font-size: $title-small;
							/* font-size: 1.9vw; */
							/* font-size: 200%; */
						}
						.client {
							font-size: $text-small;
							/* font-size: 1.1vw; */
						}
					}
				}
				.detailWrap {
					margin-left: -$w;
				}
			}
		}
		&:nth-child(2n + 1) {
			.logoWrap {
				float: left;
			}
			.contentWrap {
				float: right;
			}
		}
	}
	&.cardType {
		width: $w; height: $h;
		overflow: hidden;
		z-index: 2;
		box-shadow: 0 20px 40px rgba(0,0,0,0.3);
		.logoWrap {
			@include transition(0.4s);
			position: relative;
			width: 100%; height: $h/2;
			background-color: $c-white;
			.imgWrap {
				@include transition(0.4s);
				img {max-width: 60%; max-height:none;}
			}
		}
		.contentWrap {
			@include transition(0.4s);
			position: relative; display: block;;
			width: 100%; height: $h/2;
			overflow: hidden;
			background-size: cover; background-position: center center;
			.titleWrap {
				@include transition(0.4s);
				position: relative; display: inline-block;
				width: $w; height: $h/2;
				.txtWrap {
					@include transition(0.4s);
					position: absolute;
					top: 0; left: 0;
					padding: 20px;
					width: 90%;
					color: $c-white;
					z-index: 3;
					.titleTxt {
						font-size: $title-xsmall; font-weight: bold;
						margin-bottom: 10px;
					}
					.client {
						font-size: $text-small;
					}
				}
				.period {
					position: absolute;
					z-index: 2;
					bottom: 20px; right: 24px;
					color: $c-white; font-size: $text-small;
				}
				.cover {
					@include transition(0.4s);
					position: absolute;
					left: 0; top: 0;
					width: 100%; height: $h/2;
					z-index: 1;
					&.dark {background-color: rgba($c-black, 0.4);}
				}
				.btnLink {
					position: absolute;
					right: 10px;
					bottom: -50px;
					width: 50px; height: 50px;
					padding: 0;
					display: none;
					z-index: 5;
					transition: 0.6s bottom, 0.6s opacity;;
					svg {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
					}
				}
			}
			.detailWrap {
				@include transition(0.4s);
				position: absolute;
				top: $h/2; left: 0;
				width: $w; height: $h/4;
				margin-left: 0;
				background-color: rgba($c-blue-dark, 0.9);
				overflow: hidden;
				.txtContWrap {
					position: relative;
					width: 100%; height: 100%;
					padding: 12px 18px;
					.titleTxt {
						width: 90%;
						font-size: $title-tiny; font-weight: bold;
						color: $c-white;
						margin-bottom: 7px;
					}
					.contentTxt {
						position: relative;
						width: 100%;
						height: auto;
						color: rgba($c-white, 0.9);
						p {
							display: -webkit-box;
							height: 2.4em;
							line-height: 1.2;
							text-overflow: ellipsis;
							overflow: hidden;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
						}
					}
					.btnLink {
						position: absolute;
						right: 0;
						top: 0;
						width: 50px; height: 50px;
						padding: 5px;
						transition: 0.6s top, 0.6s opacity;;
						svg {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}
				}
			}
		}
		&:hover, &.on {
			.logoWrap {
				height: $h/4;
				.imgWrap {transform: scale(0.75);}
			}
			.contentWrap {
				height: $h/4*3;
				.detailWrap {
					top: $h/2
				}
			}
		}
		&:nth-child(2n + 1) {
			z-index: 1;
			transform: scale(0.98);
		}
	}
}

/*
	##Device = Laptops, Desktops
	##Screen = B/w 1025px to 1280px
*/
@media (min-width: 1025px) and (max-width: 1280px) {
	//CSS
	$multiple: 3;
	$w: 110px*$multiple;
	$h: 110px*$multiple;
	.listItem {
		float: none;
		&.listTop {
			width: $w*3; height: $h;
			.logoWrap {
				width: $w; height: $h;
			}
			.contentWrap {
				width: #{$w*2}; height: $w;
				.titleWrap {
					width: #{$w*2}; height: $w;
					.txtWrap {
						$mgTitle: 50px;
						bottom: $mgTitle; left: $mgTitle;
						width: calc(100% - #{$mgTitle*2});
						.titleTxt {
							font-size: $title-medium-small;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-normal;
						}
					}
					.period {
						top: 20px; right: 24px;
						font-size: $text-medium;
					}
					.cover {
						&.dark {background-color: rgba($c-black, 0.4);}
					}
				}
				.detailWrap {
					top: 0; left: 100%;
					width: $w; height: $h;
					margin-left: 0;
					.slideWrap {
						top: 0; left: 0;
						width: 100%; height: #{$w/2};
						.swiper-container {
							height: #{$w/2};
						}
					}
					.txtContWrap {
						top: 50%; left: 0;
						width: 100%; height: 50%;
						padding: 6%;
						.titleTxt {
							width: 88%;
							font-size: $title-tiny;
							margin-bottom: 12px;
						}
						.contentTxt {
							$lineNum: $multiple+1;
							$lh: 1.22em;
							width: $w*0.8;
							height: $lh*$lineNum;
							p {
								height: $lh*$lineNum - 0.02em;
								line-height: $lh;
								-webkit-line-clamp: $lineNum;
							}
						}
						.btnLink {
							right: 0;
							bottom: 0;
							width: $w/8; height: $h/8;
						}
					}
				}
			}
			&:hover, &.on {
				.contentWrap {
					.titleWrap {
						width: $w;
						.txtWrap {
							left: 40px;
							.titleTxt {
								font-size: $title-small;
							}
							.client {
								font-size: $text-small;
							}
						}
					}
					.detailWrap {
						margin-left: -$w;
					}
				}
			}
		}
		&.cardType {
			width: $w; height: $h;
			.logoWrap {
				width: 100%; height: $h/2;
			}
			.contentWrap {
				width: 100%; height: $h/2;
				.titleWrap {
					width: $w; height: $h/2;
					.txtWrap {
						top: 0; left: 0;
						padding: 20px;
						width: 90%;
						.titleTxt {
							font-size: $title-xsmall;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-small;
						}
					}
					.period {
						bottom: 20px; right: 24px;
						color: $c-white; font-size: $text-small;
					}
					.cover {
						left: 0; top: 0;
						width: 100%; height: $h/2;
					}
				}
				.detailWrap {
					top: $h/2; left: 0;
					width: $w; height: $h/4;
					.txtContWrap {
						position: relative;
						width: 100%; height: 100%;
						padding: 10px 16px;
						.titleTxt {
							width: 90%;
							font-size: $title-xtiny;
							margin-bottom: 5px;
						}
						.contentTxt {
							width: 100%;
							height: auto;
							p {
								height: 2.4em;
								line-height: 1.2em;
								-webkit-line-clamp: 2;
								font-size: 0.9em;
							}
						}
						.btnLinkWrap {
							right: 0;
							bottom: 0;
							top: auto;
							width: 40px; height: 40px;
						}
					}
				}
			}
			&:hover, &.on {
				.logoWrap {
					height: $h/4;
				}
				.contentWrap {
					height: $h/4*3;
					.detailWrap {
						top: $h/2
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (portrait)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) {
	//CSS
	.listItem {
		float: none;
		&.listTop {
			$multiple: 3;
			$w: 84px*$multiple;
			$h: 84px*$multiple;
			width: $w*3; height: $h;
			margin-bottom: 10px;
			&:nth-child(2n+1) {
				margin-left: -5px;
			}
			&:nth-child(2n) {
				margin-left: 5px;
			}
			.logoWrap {
				width: $w; height: $h;
			}
			.contentWrap {
				width: #{$w*2}; height: $w;
				.titleWrap {
					width: #{$w*2}; height: $w;
					.txtWrap {
						$mgTitle: 32px;
						bottom: $mgTitle; left: $mgTitle;
						width: calc(100% - #{$mgTitle*2});
						.titleTxt {
							font-size: $title-small;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-small;
						}
					}
					.period {
						top: 20px; right: 24px;
						// font-size: $text-medium;
						font-size: $text-normal-small;
					}
					.cover {
						&.dark {background-color: rgba($c-black, 0.4);}
					}
				}
				.detailWrap {
					top: 0; left: 100%;
					width: $w; height: $h;
					margin-left: 0;
					.slideWrap {
						top: 0; left: 0;
						width: 100%; height: #{$w/2};
						.swiper-container {
							height: #{$w/2};
						}
					}
					.txtContWrap {
						top: 50%; left: 0;
						width: 100%; height: 50%;
						padding: 6%;
						.titleTxt {
							width: 88%;
							font-size: $title-tiny;
							margin-bottom: 12px;
						}
						.contentTxt {
							$lineNum: $multiple;
							$lh: 1.22em;
							width: $w*0.8;
							height: $lh*$lineNum;
							p {
								font-size: $text-tiny;
								height: $lh*$lineNum - 0.02em;
								line-height: $lh;
								-webkit-line-clamp: $lineNum;
							}
						}
						.btnLink {
							right: 0;
							bottom: 0;
							width: $w/8; height: $h/8;
						}
					}
				}
			}
			&:hover, &.on {
				.contentWrap {
					.titleWrap {
						width: $w;
						.txtWrap {
							left: 30px;
							.titleTxt {
								font-size: $title-xsmall;
							}
							.client {
								font-size: $text-tiny;
							}
						}
						.period {
							font-size: $text-small;
						}
					}
					.detailWrap {
						margin-left: -$w;
					}
				}
			}
		}
		&.cardType {
			$multiple: 3;
			$w: 84px*$multiple;
			$h: 84px*$multiple*1.5;
			width: $w; height: $h;
			.logoWrap {
				width: 100%; height: $h/2;
			}
			.contentWrap {
				width: 100%; height: $h/2;
				.titleWrap {
					width: $w; height: $h/2;
					.txtWrap {
						top: 0; left: 0;
						padding: 18px;
						width: 100%;
						.titleTxt {
							font-size: $title-tiny;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-small;
						}
					}
					.period {
						bottom: 20px; right: 24px;
						color: $c-white; font-size: $text-small;
					}
					.cover {
						left: 0; top: 0;
						width: 100%; height: $h/2;
					}
				}
				.detailWrap {
					top: $h/2; left: 0;
					width: $w; height: $h/4;
					.txtContWrap {
						position: relative;
						width: 100%; height: 100%;
						padding: 10px 16px;
						.titleTxt {
							width: 90%;
							font-size: $title-xtiny;
							margin-bottom: 5px;
						}
						.contentTxt {
							width: 100%;
							height: auto;
							p {
								height: 2.4em;
								line-height: 1.2em;
								-webkit-line-clamp: 2;
								font-size: 0.9em;
							}
						}
						.btnLinkWrap {
							right: 0;
							bottom: 0;
							top: auto;
							width: 40px; height: 40px;
						}
					}
				}
			}
			&:hover, &.on {
				.logoWrap {
					height: $h/4;
				}
				.contentWrap {
					height: $h/4*3;
					.detailWrap {
						top: $h/2
					}
				}
			}
		}
	}
}

/*
	##Device = Tablets, Ipads (landscape)
	##Screen = B/w 768px to 1024px
*/
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
	//CSS
	.listItem {
		&.listTop {
			$multiple: 3;
			$w: 100px*$multiple;
			$h: 100px*$multiple;
			width: $w*3; height: $h;
			.logoWrap {
				width: $w; height: $h;
			}
			.contentWrap {
				width: #{$w*2}; height: $w;
				.titleWrap {
					width: #{$w*2}; height: $w;
					.txtWrap {
						$mgTitle: 30px;
						bottom: $mgTitle; left: $mgTitle;
						width: calc(100% - #{$mgTitle*2});
						.titleTxt {
							font-size: $title-medium-small;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-normal;
						}
					}
					.period {
						top: 20px; right: 24px;
						// font-size: $text-medium;
						font-size: $text-normal-small;
					}
					.cover {
						&.dark {background-color: rgba($c-black, 0.4);}
					}
				}
				.detailWrap {
					top: 0; left: 100%;
					width: $w; height: $h;
					margin-left: 0;
					.slideWrap {
						top: 0; left: 0;
						width: 100%; height: #{$w/2};
						.swiper-container {
							height: #{$w/2};
						}
					}
					.txtContWrap {
						top: 50%; left: 0;
						width: 100%; height: 50%;
						padding: 6%;
						.titleTxt {
							width: 88%;
							font-size: $title-tiny;
							margin-bottom: 12px;
						}
						.contentTxt {
							$lineNum: $multiple+1;
							$lh: 1.22em;
							width: $w*0.8;
							height: $lh*$lineNum;
							p {
								height: $lh*$lineNum - 0.02em;
								line-height: $lh;
								-webkit-line-clamp: $lineNum;
							}
						}
						.btnLink {
							right: 0;
							bottom: 0;
							width: $w/8; height: $h/8;
						}
					}
				}
			}
			&:hover, &.on {
				.contentWrap {
					.titleWrap {
						width: $w;
						.txtWrap {
							// left: 40px;
							.titleTxt {
								font-size: $title-small;
								line-height: 1.4;
							}
							.client {
								font-size: $text-small;
							}
						}
						.period {
						font-size: $text-small;
						}
					}
					.detailWrap {
						margin-left: -$w;
					}
				}
			}
		}
		&.cardType {
			$multiple: 3;
			$w: 90px*$multiple;
			$h: 90px*$multiple*1.2;
			width: $w; height: $h;
			.logoWrap {
				width: 100%; height: $h/2;
			}
			.contentWrap {
				width: 100%; height: $h/2;
				.titleWrap {
					width: $w; height: $h/2;
					.txtWrap {
						top: 0; left: 0;
						padding: 20px;
						width: 90%;
						.titleTxt {
							font-size: $title-tiny;
							margin-bottom: 10px;
						}
						.client {
							font-size: $text-small;
						}
					}
					.period {
						bottom: 20px; right: 24px;
						color: $c-white; font-size: $text-small;
					}
					.cover {
						left: 0; top: 0;
						width: 100%; height: $h/2;
					}
				}
				.detailWrap {
					top: $h/2; left: 0;
					width: $w; height: $h/4;
					.txtContWrap {
						position: relative;
						width: 100%; height: 100%;
						padding: 10px 16px;
						.titleTxt {
							width: 90%;
							font-size: $title-xtiny;
							margin-bottom: 5px;
						}
						.contentTxt {
							width: 100%;
							height: auto;
							p {
								height: 2.4em;
								line-height: 1.2em;
								-webkit-line-clamp: 2;
								font-size: 0.9em;
							}
						}
						.btnLinkWrap {
							right: 0;
							bottom: 0;
							top: auto;
							width: 40px; height: 40px;
						}
					}
				}
			}
			&:hover, &.on {
				.logoWrap {
					height: $h/4;
				}
				.contentWrap {
					height: $h/4*3;
					.detailWrap {
						top: $h/2
					}
				}
			}
		}
	}
}

/*
	##Device = Low Resolution Tablets, Mobiles (Landscape)
	##Screen = B/w 481px to 767px
*/
@media (min-width: 481px) and (max-width: 767px) {
	//CSS
	.listItem {
		float: none;
		max-width: 480px;
		&.listTop {
			$multiple: 1;
			$nav: 74px;
			$w: 100%;
			$h: 100%;
			$logoWrap: 12%;
			width: 94%; height: calc(100vh - 114px - #{$nav});
			min-height: 440px;
			margin-left: 0; margin-bottom: 20px;
			&:nth-child(2n+1) {
				margin-left: 0;
			}
			.logoWrap {
				width: $w; height: $logoWrap;
				min-height: 48px;
				.imgWrap {
					img {max-width: 24%;}
				}
			}
			.contentWrap {
				float: unset;
				width: #{$w}; height: calc(#{$h} - #{$logoWrap});
				.titleWrap {
					display: block;
					width: #{$w}; height: 52%;
					.txtWrap {
						$mgTitle: 22px;
						bottom: $mgTitle; left: $mgTitle;
						width: calc(100% - #{$mgTitle*2});
						.titleTxt {
							line-height: 32px;
							margin-bottom: 10px;
							font-size: $title-normal-small; font-weight: bold;
						}
						.client {
							font-size: $text-small;
							opacity: .8;
						}
					}
					.period {
						top: 16px; right: 22px;
						font-size: $text-small;
						opacity: .8;
					}
					.cover {
						&.dark {background-color: rgba($c-black, 0.25);}
					}
				}
				.detailWrap {
					position: relative;
					top: 0; left: 0;
					width: $w; height: 48%;
					margin-left: 0;
					.slideWrap {
						display: none;
					}
					.txtContWrap {
						position: unset;
						width: 100%; height: 100%;
						padding: 22px;
						.titleTxt {
							width: 88%;
							margin-bottom: 14px;
							font-size: $title-tiny;
							opacity: .9;
						}
						.contentTxt {
							$lineNum: $multiple*5;
							$lh: 1.22em;
							width: $w*0.8; height: $lh*$lineNum;
							p {
								line-height: $lh;
								height: $lh*$lineNum - 0.04em;
								-webkit-line-clamp: $lineNum;
								font-size: $text-small;
							}
						}
						.btnLink {
							right: 10px; bottom: 6px;
							background-color: transparent;
							opacity: .55;
						}
					}
				}
			}
			&:hover, &.on {
				.contentWrap {
					.titleWrap {
						width: $w;
						.txtWrap {
							left: 22px;
							.titleTxt {
								font-size: $title-normal-small;
							}
							.client {
								font-size: $text-small;
							}
						}
					}
					.detailWrap {
						margin-left: 0;
					}
				}
			}
		}
		&.cardType {
			$multiple: 1;
			$w: 100%;
			$h: 100%;
			$nav: 74px;
			$logoWrap: 14%;
			$contentWrap: calc(#{$h} - #{$logoWrap});
			$detailWrap: 46%;
			width: 94%; height: calc(100vh - 314px - #{$nav});
			min-height: 370px;
			margin-bottom: 8px;
			.logoWrap {
				position: absolute;
				top: 0;
				width: $w; height: $logoWrap;
				.imgWrap {
					transform: scale(.55);
					img {
						max-width: 34%;
					}
				}
			}
			.contentWrap {
				position: absolute;
				top: $logoWrap;
				width: $w; height: $contentWrap;
				.titleWrap {
					display: block;
					width: $w; height: calc(#{$h} - #{$detailWrap});
					.txtWrap {
						top: unset; left: 0; bottom: 0;
						padding: 0 22px 0 20px;
						width: $w; height: 76%;
						.titleTxt {
							position: absolute;
							bottom: 48px;
							line-height: 32px;
							width: calc(100% - 42px);
							font-size: $title-normal-small;
							margin-bottom: 12px;
						}
						.client {
							position: absolute;
							bottom: 22px;
							font-size: $text-small;
							opacity: .8;
						}
					}
					.period {
						top: 14px; right: 22px;
						color: $c-white; font-size: $text-small;
						opacity: .8;
					}
					.cover {
						left: 0; top: 0;
						width: $w; height: $h;
					}
					.btnLink {
						display: block;
						bottom: 10px;
					}
				}
				.detailWrap {
					position: relative;
					top: 0; left: 0;
					width: $w; height: $detailWrap;
					.txtContWrap {
						position: relative;
						width: $w; height: $h;
						padding: 22px;
						.titleTxt {
							width: 90%;
							margin-bottom: 14px;
							font-size: $title-xtiny;
							opacity: .9;
						}
						.contentTxt {
							width: $w;
							height: auto;
							p {
								height: 2.4em;
								line-height: 1.2em;
								-webkit-line-clamp: 2;
								// font-size: 0.9em;
								font-size: $text-small;
								opacity: .8;
							}
						}
						.btnLinkWrap {
							top: auto; right: 8px; bottom: 6px;
							width: 50px; height: 50px;
							padding: 0;
							opacity: 0.55;
						}
					}
				}
			}
			&:hover, &.on {
				.logoWrap {
					height: $logoWrap;
					.imgWrap {
						transform: scale(.55);
					}
				}
				.contentWrap {
					height: $contentWrap;
					.detailWrap {
						top: 0;
					}
				}
			}
			&:nth-child(2n + 1) {
				z-index: 2;
				transform: scale(1);
			}
		}
	}
}

/*
	##Device = Most of the Smartphones Mobiles (Portrait)
	##Screen = B/w 320px to 479px
*/
@media (min-width: $mnWMobile) and (max-width: 480px) {
  //CSS
  .listItem {
		&.listTop {
			$multiple: 1;
			$nav: 74px;
			$w: 100%;
			$h: 320px;
			$logoWrap: 70px;
			width: $w; height: auto; // height: calc(100vh - 14px - #{$nav});
			margin-left: 0; margin-bottom: 20px;
			&:nth-child(2n+1) {
				margin-left: 0;
			}
			.logoWrap {
				width: $w; height: $logoWrap;
				.imgWrap {
					img {max-width: 35%;}
				}
			}
			.contentWrap {
				float: unset;
				width: #{$w}; height: auto;
				.titleWrap {
					display: block;
					width: #{$w}; height: calc(#{$h} - #{$logoWrap});
					.txtWrap {
						$mgTitle: 22px;
						bottom: $mgTitle; left: $mgTitle;
						width: calc(100% - #{$mgTitle*2});
						.titleTxt {
							line-height: 32px;
							margin-bottom: 10px;
							font-size: $title-xsmall; font-weight: bold;
						}
						.client {
							font-size: $text-small;
							opacity: .8;
						}
					}
					.period {
						top: 16px; right: 22px;
						font-size: $text-small;
						opacity: .8;
					}
					.cover {
						&.dark {background-color: rgba($c-black, 0.25);}
					}
				}
				.detailWrap {
					transition: none;
					position: relative;
					top: 0; left: 0;
					width: $w; height: 0; // 180px 변경
					margin-left: 0;
					.slideWrap {
						display: none;
					}
					.txtContWrap {
						position: unset;
						width: 100%; height: auto;
						padding: 6%;
						.titleTxt {
							width: 88%;
							margin-bottom: 14px;
							font-size: $title-tiny;
							opacity: .9;
						}
						.contentTxt {
							$lineNum: $multiple*5;
							$lh: 1.22em;
							width: $w; height: $lh*$lineNum;
							p {
								line-height: $lh;
								height: $lh*$lineNum - 0.02em;
								-webkit-line-clamp: $lineNum;
								font-size: $text-tiny;
							}
						}
						.btnLink {
							right: 10px; bottom: 6px;
							background-color: transparent;
							opacity: .55;
							z-index: 5;
						}
					}
				}
			}
			&:hover, &.on {
				.contentWrap {
					.titleWrap {
						width: $w;
						.txtWrap {
							left: 22px;
							.titleTxt {
								font-size: $title-xsmall;
							}
							.client {
								font-size: $text-small;
							}
						}
					}
					.detailWrap {
						margin-left: 0;
					}
				}
			}
			&.on {
				.contentWrap {
					.detailWrap {
						height: auto;
					}
				}
			}
		}
		&.cardType {
			$multiple: 1;
			$w: 100%;
			$h: 320px;
			$nav: 74px;
			$logoWrap: 70px;
			$contentWrap: calc(#{$h} - #{$logoWrap});
			width: $w; height: auto; // height: calc(64vh - #{$nav});
			margin-bottom: 20px;
			.logoWrap {
				position: unset;
				top: 0;
				width: $w; height: $logoWrap;
				.imgWrap {
					transform: scale(.55);
				}
			}
			.contentWrap {
				position: unset;
				top: $logoWrap;
				width: $w; height: auto;
				.titleWrap {
					display: block;
					width: $w; height: $contentWrap;
					.txtWrap {
						top: unset; left: 0; bottom: 22px;
						margin: 0 22px 0 20px; padding: 0;
						width: calc(#{$w} - 22px - 20px); height: 76%;
						.titleTxt {
							position: absolute;
							bottom: 34px;
							font-size: $title-xsmall;
							margin-bottom: 0;
						}
						.client {
							position: absolute;
							bottom: 0;
							font-size: $text-small;
							opacity: .8;
						}
					}
					.period {
						top: 14px; right: 22px;
						color: $c-white; font-size: $text-small;
						opacity: .8;
					}
					.cover {
						left: 0; top: 0;
						width: $w; height: $contentWrap;
						&.dark {
							background-color: rgba(0, 0, 0, .25);
						}
					}
					.btnLink {
						display: block;
						bottom: 10px;
					}
				}
				.detailWrap {
					transition: none;
					position: relative;
					top: 0; left: 0;
					width: $w; height: 0;
					.txtContWrap {
						position: relative;
						width: $w; height: auto;
						padding: 10px 20px 54px 20px;
						.titleTxt {
							width: 90%;
							margin-bottom: 8px;
							font-size: $title-xtiny;
							opacity: .9;
						}
						.contentTxt {
							width: $w;
							height: auto;
							p {
								height: 2.4em;
								line-height: 1.2em;
								-webkit-line-clamp: 2;
								font-size: 0.9em;
								opacity: .8;
							}
						}
						.btnLinkWrap {
							top: -50px; right: 10px; bottom: 4px;
							width: 50px; height: 50px;
							padding: 0;
							opacity: 0;
						}
					}
				}
			}
			&:hover, &.on {
				.logoWrap {
					height: $logoWrap;
					.imgWrap {
						transform: scale(.55);
					}
				}
				.contentWrap {
					height: auto;
					.detailWrap {
						top: 0;
					}
				}
			}
			&.on {
				.titleWrap {
					.btnLink {
						bottom: -128px;
						opacity: 0;
					}
				}
				.contentWrap {
					.detailWrap {
						height: auto;
						.txtContWrap {
							.btnLinkWrap {
								top: auto;
								opacity: 0.55;
							}
						}
					}
				}
			}
			&:nth-child(2n + 1) {
				z-index: 2;
				transform: scale(1);
			}
		}
	}
}
</style>
